import styled from 'styled-components'

export const Vimoneloding = styled.img`
    z-index: 99;
    width: 100px;
    position: relative;
    top: 45%;
    transition: all .5s ease;
`

export const LoadingWrap = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
    margin: auto;
    background : ${props => props.background ? props.background : ""};
`

export const Container = styled.div`
    position: relative;
    top: 45%;
`

export const LoadingText = styled.div`
    color: ${({ reversal }) => reversal ? 'white' : 'black'};
    flex: 2;
    padding-top: 5px;
`

export const FlexloadingText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    margin: auto;
    flex-direction: column;
`